
import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more';
import highcharts3D from 'highcharts/highcharts-3d';
import HC_accessibility from 'highcharts/modules/accessibility';
highcharts3D(Highcharts);
More(Highcharts);
import { HttpClient } from '@angular/common/http';
import { ScatterchartService } from '../../scatterchart.service';
import { Observable } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';



@Component({
  selector: 'app-bubble-chart',
  templateUrl: './bubblechart01.component.html',
  styleUrls: []
})
export class Bubblechart01ComponentCustom implements OnInit {
  chart: any;
  seriesData: any = [];
  chartproperties: any;
  sampleSizeConstandValue = 8000;
  properties: any;
  title: any;

  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any=0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any="24em";
  
  constructor(private http: HttpClient, private scatterchartService: ScatterchartService, private _customSnapshotService:CustomsnapshotService) { }

  ngOnInit(): void {
    this.http.get<any>('assets/Data/bubbleData.json').subscribe((data: any) => {
      this.title = data[0]["title"];
      this.seriesData = data[0]["data"];
      this.properties = data[0]["properties"]
      this.chartproperties = data[0]["properties"][0];
      this.chartproperties.showLegend=true;
      this.getBubbleChart('chart-container', this.seriesData, this.chartproperties);
    });
  }


  customization(): Observable<any[]> {
    return this._customSnapshotService.getChartCustomization("Bubble Chart",this._customSnapshotService.selectedSnapshotType?.name);
    
  }


  getBubbleChart(containerid: string, seriesData: any, chartproperties: any) {
    localStorage.setItem("properties", JSON.stringify(chartproperties));
    const SeriesData = seriesData.map((item: any, index: number) => {
      const brandInfo: any = this.scatterchartService.bubbleupdatedCategories.find(
        (category: { name: any }) => category.name === item.brand);
      return {
        name: item.brand,
        type: 'bubble',
        color: this.scatterchartService.bubblecolors[index],
        data: item.data.map((dataItem: any) => ({
          x:
            chartproperties.datalabelStyle === 'ls' &&
              item['Sample size'] < this.sampleSizeConstandValue
              ? 0
              : Number(parseFloat(item.x_axis).toFixed(this.chartproperties.decimalRoundOff)),
          y:
            chartproperties.datalabelStyle === 'ls' &&
              item['Sample size'] < this.sampleSizeConstandValue
              ? 0
              :Number(parseFloat(item.y_axis).toFixed(this.chartproperties.decimalRoundOff)),
          z: item.bubble_size,
          significance: item.Significance,
          significance1: item.Significance1,
          cv: item['ChangeVs'],
          samplesize: item['Sample size'],
        })),
        ...(brandInfo && chartproperties['image'] && {
          marker: {
            symbol: `url(${brandInfo.image})`,
            width: brandInfo.bubble_size,
            height: brandInfo.bubble_size,
          },
        }),
      };
    });



    this.chart = Highcharts.chart(containerid, {
      chart: {
        type: 'bubble',
        backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
        plotBorderColor: 'lightgrey',
        plotBorderWidth: 0.5,
        style:{
          fontFamily:this.scatterchartService.fontFamily,
        },
        options3d: {
          enabled: chartproperties.is3DChart,
          alpha: -1,
          beta: -1,
          depth: 190,
          viewDistance: 4,
          fitToPlot: false,
        },
        zoomType: 'xy',
      },
      title: {
        text: "",
        align: chartproperties.chartTitlePosition,
        verticleAlign: 'top',
        style: {
          color: chartproperties.darkTheme ? 'white' : 'black',
        },
      },
      legend: {
        enabled: chartproperties.showLegend,
        layout:
          chartproperties.legendPosition !== 'bottom' ? 'vertical' : 'horizontal',
        verticalAlign:
          chartproperties.legendPosition !== 'bottom' ? 'middle' : 'bottom',
        align:
          chartproperties.legendPosition === 'bottom'
            ? 'center'
            : chartproperties.legendPosition,
        itemStyle: {
          color: chartproperties.darkTheme ? 'white' : 'black',
          fontFamily: "KantarBrown-Regular",
          fontSize: "0.8em",
          fontWeight: "normal"
        },
      },

      xAxis: {
        title: {
          text: '',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        gridLineColor: 'lightgrey',
        gridLineWidth: chartproperties.gridlines ? 0.4 : 0,
        labels: {
          rotation:this.chartproperties.axisLabelOrientation==='vertical'?-90:(this.chartproperties.axisLabelOrientation==='angles'?-45:0),
          format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
      },
      yAxis: {
        title: {
          text: '',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true,
        gridLineWidth: chartproperties.gridlines ? 1 : 0,
        labels: {
          rotation:this.chartproperties.yaxisLabelOrientation==='vertical'?-90:(this.chartproperties.yaxisLabelOrientation==='angles'?-45:0),
          format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
      },
      credits: {
        enabled: false
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        formatter: function (this: Highcharts.TooltipFormatterContextObject) {
          const pointWithMetric = this.point as {
            y: number;
            metric?: string;
            z?: number;
          };

          let isDefaultTooltip = chartproperties.toolTipStyle;
          if (isDefaultTooltip == "style1") {
            const dotColor = this.series.color;
            const commonContent =
              `<div style="border-left: 5px solid ${dotColor};  border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 0px; border-radius: 5px; margin: 0; background-color: white;">` +
              `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 11px;">Tooltip Title</span>` +
              `<span><strong>Category Name:</strong></span> ${this.series.name}<br>` +
              `<span><strong>Value:</strong></span> ${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''} <br>` +
              `<span><strong>Bubble Size:</strong></span> ${pointWithMetric.z}`;
            return commonContent + '</div>';
          }

          else {
            const dotColor = this.series.color;
            const content =
              `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
              ` ${this.series.name}` +
              `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</div>`;

            return content + '</div>';

          }
        },
      },
      plotOptions: {
        series: {
          shadow: true,
          animation: false
        },
        bubble: {
          dataLabels: {
            rotation: chartproperties.datalabelOrientation,
            enabled: chartproperties.showDataLabel,
            formatter: function (
              this: Highcharts.TooltipFormatterContextObject
            ) {
              const seriesWithBrand = this.point as {
                y: number;
                brand?: string;
                cv?: string;
                significance?: string;
                significance1?: string;
                samplesize?: number;
              };
              let tooltipContent = '';

              if (chartproperties.datalabelStyle === 'datalabel') {

                return `<span>${this.series.name}</span><br>${this.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}`;
              }
              if (chartproperties.datalabelStyle === 'change') {

                return `${seriesWithBrand.y} ${chartproperties.datalabelFormat === 'percentage' ? '%' : ''} <span style="font-size: 80%;color:${chartproperties.darkTheme ? 'white' : 'black'};">(${seriesWithBrand.cv})</span>`;

              } else if (chartproperties.datalabelStyle === 'significance') {

                tooltipContent = `${seriesWithBrand.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}`;
              }
              if (chartproperties.datalabelStyle == "significance2") {
                let changeColor = seriesWithBrand.significance1 && Number(seriesWithBrand.significance1) < 0 ? 'red' : (seriesWithBrand.significance1 && Number(seriesWithBrand.significance1) > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                tooltipContent = `${seriesWithBrand.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''} <span style="color: ${changeColor}; font-size: 80%">(${seriesWithBrand.cv})</span> `;
              }
              else if (
                chartproperties.datalabelStyle === 'significance + changeVs'
              ) {

                tooltipContent = `<span>${seriesWithBrand.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''} <span style="font-size: 80%;color:${chartproperties.darkTheme ? 'white' : 'black'}">(${seriesWithBrand.cv})</span> </span>`;
              } else if (chartproperties.datalabelStyle === 'ls') {

                if (
                  seriesWithBrand.samplesize &&
                  seriesWithBrand.samplesize < 9000
                ) {
                  return 'LS';
                }
                return `<span> ${seriesWithBrand.y} ${chartproperties.datalabelFormat == 'percentage' ? '%' : ''}</span><br>`;
              }
              if (seriesWithBrand.significance === '1') {
                tooltipContent +=
                  '<span style="color: green;"> &#9650;</span>';
              } else if (seriesWithBrand.significance === '-1') {
                tooltipContent += '<span style="color: red;"> &#9660;</span>';
              } else {
                tooltipContent += '';
              }
              return tooltipContent;

            },
            verticalAlign: 'top',
            y: chartproperties.datalabelStyle === 'default' ? -36 : -20,
            style: {
              fontSize: chartproperties.dataLabelSize,
              textOutline: 'none',
              color:
                chartproperties.dataLabelColor == 'Default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
                fontWeight: "normal",
            },
          },
          maxSize: chartproperties.markersize !== 'default' ? chartproperties.markersize : null,

          shadow: {
            color: 'rgba(0,0,0,0.5)',
            offsetX: 0,
            offsetY: 0,
            opacity: 0.5,
            width: 5,
          },

        },
      },
      series: SeriesData,
    } as Highcharts.Options);
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.scatterchartService.applycustomization(event,item, this.chartproperties)
    this.getBubbleChart('chart-container', this.seriesData, this.chartproperties);
    }

  userselectedproperties() {

    const jsonData = {
      title: this.title,
      data: this.seriesData,
      properties: this.properties
    }

    return JSON.stringify(jsonData);
  }
}

